<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <span v-if="!$_updateActionAllowed" class="lock" :title="'Nastavení globálního zdroje obsahu nelze editovat.' | translate">S</span>
          <input
              type="checkbox"
              :id="entity.id"
              :value="entity.id"
              @click.stop
              @change="onChange"
              :checked="isChecked"
          />
          <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
      <span class="lock" v-if="!$_updateActionAllowed" :title="'Nastavení globálního zdroje obsahu nelze editovat.' | translate" v-translate>Zamčeno</span>
        <td :data-th="'Název zdroje obsahu' | translate" class="first_data"><strong>{{ entity.hostname }}</strong></td>
        <td :data-th="'Začátek údržby' | translate" v-html="$_date_formatFull(entity.start_timestamp)"></td>
        <td :data-th="'Konec údržby' | translate" v-html="$_date_formatFull(entity.end_timestamp)"></td>
        <td :data-th="'Popis' | translate">{{ entity.description }}</td>
        <td :data-th="'Datum vytvoření' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
        <td :data-th="'Datum poslední editace' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
        <td class="no_padding edit">
          <div class="edit_inner">
            <a v-if="$_updateActionAllowed"
               class="btn btn_action btn_delete"
               :title="'Smazat' | translate"
               @click.prevent.stop="emitDeleteMaintenanceWindow"
               v-translate>Smazat
            </a>
          </div>
        </td>
    </tr>
</template>

<script>
	import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "ContentSourceMaintenanceWindowRow",
		mixins: [rowActions],
		data() {
			return {
				moduleName: 'contentSourceMaintenanceWindows',
				detailPageRouteName: 'contentSourceMaintenanceWindowDetail',
			}
		},
    methods: {
      emitDeleteMaintenanceWindow() {
        this.$emit('deleteEntity', this.entity.id)
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowRow.vue